"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SourceType;
(function (SourceType) {
    SourceType["searchEntity"] = "searchEntity";
})(SourceType = exports.SourceType || (exports.SourceType = {}));
//# sourceMappingURL=SourceType.js.map